import { Card, Group, Text, useMantineColorScheme } from "@mantine/core";
import { useTranslation } from 'react-i18next';
import PropTypes from "prop-types";

const HelpCard = ({ title, description, id, type }) => {
  const { t } = useTranslation();
  const { colorScheme } = useMantineColorScheme();
  return (
    <Card card-id={id} shadow="sm" padding="lg" withBorder style={styles.card}>
      <Card.Section
        withBorder
        inheritPadding
        py="xs"
        className={`sidebar-content ${
          colorScheme === "dark" ? "dark-mode" : "light-mode"
        }`}
      >
        <Group position="apart" style={{ justifyContent: "flex-start" }}>
          <Text size={"lg"} order={4}>
            {t('help.inputName')}
          </Text>
          <Text>{title}</Text>
        </Group>
      </Card.Section>
      <Card.Section withBorder inheritPadding py="xs"  className={`${
          colorScheme === "dark" ? "dark-mode" : "light-mode"
        }`}>
        <Group position="apart" style={{ justifyContent: "flex-start" }}>
          <Text order={4}>{t('help.type')}</Text>
          <Text>{type}</Text>
        </Group>
      </Card.Section>
      <Card.Section withBorder inheritPadding py="xs"  className={`${
          colorScheme === "dark" ? "dark-mode" : "light-mode"
        }`}>
        <Group position="apart">
          <Text order={4}>{t('help.description')}</Text>
        </Group>
      </Card.Section>
      <Card.Section withBorder inheritPadding py="xs" className={`${
          colorScheme === "dark" ? "dark-mode" : "light-mode"
        }`}>
        <Text

          color={`${colorScheme === "dark" ? "dark-mode" : "dimmed"}`}
          style={styles.label}
        >
          {description || t('help.descriptionFallback')}
        </Text>
      </Card.Section>
    </Card>
  );
};

const styles = {
  card: {
    maxWidth: "400px",
    margin: "20px auto",
  },
  label: {
    margin: "10px 0",
  },
};

HelpCard.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  id: PropTypes.string,
  type: PropTypes.string,
};

export default HelpCard;
